export default [
    {
        key: "af",
        text: "아프리칸스어 - Afrikaans"
    },
    {
        key: "am",
        text: "암하라어 - አማርኛ"
    },
    {
        key: "an",
        text: "아라곤어 - Aragonese"
    },
    {
        key: "ar",
        text: "아랍어 - العربية"
    },
    {
        key: "as",
        text: "아삼어 - অসমীয়া"
    },
    {
        key: "ast",
        text: "아스투리아어 - asturianu"
    },
    {
        key: "az",
        text: "아제르바이잔어 - azərbaycan"
    },
    {
        key: "be",
        text: "벨라루스어 - беларуская"
    },
    {
        key: "bg",
        text: "불가리아어 - български"
    },
    {
        key: "bn",
        text: "벵골어 - বাংলা"
    },
    {
        key: "br",
        text: "브르타뉴어 - brezhoneg"
    },
    {
        key: "bs",
        text: "보스니아어 - bosanski"
    },
    {
        key: "ca",
        text: "카탈로니아어 - català"
    },
    {
        key: "ceb",
        text: "세부아노어 - Cebuano"
    },
    {
        key: "chr",
        text: "체로키어 - ᏣᎳᎩ"
    },
    {
        key: "ckb",
        text: "소라니 쿠르드어 - کوردیی ناوەندی"
    },
    {
        key: "co",
        text: "코르시카어 - Corsican"
    },
    {
        key: "cs",
        text: "체코어 - Čeština"
    },
    {
        key: "cy",
        text: "웨일스어 - Cymraeg"
    },
    {
        key: "da",
        text: "덴마크어 - Dansk"
    },
    {
        key: "de",
        text: "독일어 - Deutsch"
    },
    {
        key: "de-AT",
        text: "독일어(오스트리아) - Deutsch (Österreich)"
    },
    {
        key: "de-CH",
        text: "독일어(스위스) - Deutsch (Schweiz)"
    },
    {
        key: "de-DE",
        text: "독일어(독일) - Deutsch (Deutschland)"
    },
    {
        key: "de-LI",
        text: "독일어(리히텐슈타인) - Deutsch (Liechtenstein)"
    },
    {
        key: "el",
        text: "그리스어 - Ελληνικά"
    },
    {
        key: "en",
        text: "영어 - English"
    },
    {
        key: "en-AU",
        text: "영어(오스트레일리아) - English (Australia)"
    },
    {
        key: "en-CA",
        text: "영어(캐나다) - English (Canada)"
    },
    {
        key: "en-GB",
        text: "영어(영국) - English (United Kingdom)"
    },
    {
        key: "en-IN",
        text: "영어(인도) - English (India)"
    },
    {
        key: "en-NZ",
        text: "영어(뉴질랜드) - English (New Zealand)"
    },
    {
        key: "en-US",
        text: "영어(미국) - English (United States)"
    },
    {
        key: "en-ZA",
        text: "영어(남아프리카) - English (South Africa)"
    },
    {
        key: "eo",
        text: "에스페란토어 - esperanto"
    },
    {
        key: "es",
        text: "스페인어 - Español"
    },
    {
        key: "es-419",
        text: "스페인어(라틴 아메리카) - Español (Latinoamérica)"
    },
    {
        key: "es-AR",
        text: "스페인어(아르헨티나) - Español (Argentina)"
    },
    {
        key: "es-CL",
        text: "스페인어(칠레) - Español (Chile)"
    },
    {
        key: "es-CO",
        text: "스페인어(콜롬비아) - Español (Colombia)"
    },
    {
        key: "es-CR",
        text: "스페인어(코스타리카) - Español (Costa Rica)"
    },
    {
        key: "es-ES",
        text: "스페인어(스페인) - Español (España)"
    },
    {
        key: "es-HN",
        text: "스페인어(온두라스) - Español (Honduras)"
    },
    {
        key: "es-MX",
        text: "스페인어(멕시코) - Español (México)"
    },
    {
        key: "es-PE",
        text: "스페인어(페루) - Español (Perú)"
    },
    {
        key: "es-US",
        text: "스페인어(미국) - Español (Estados Unidos)"
    },
    {
        key: "es-UY",
        text: "스페인어(우루과이) - Español (Uruguay)"
    },
    {
        key: "es-VE",
        text: "스페인어(베네수엘라) - Español (Venezuela)"
    },
    {
        key: "et",
        text: "에스토니아어 - eesti"
    },
    {
        key: "eu",
        text: "바스크어 - euskara"
    },
    {
        key: "fa",
        text: "페르시아어 - فارسی"
    },
    {
        key: "fi",
        text: "핀란드어 - Suomi"
    },
    {
        key: "fil",
        text: "필리핀어 - Filipino"
    },
    {
        key: "fo",
        text: "페로어 - føroyskt"
    },
    {
        key: "fr",
        text: "프랑스어 - Français"
    },
    {
        key: "fr-CA",
        text: "프랑스어(캐나다) - Français (Canada)"
    },
    {
        key: "fr-CH",
        text: "프랑스어(스위스) - Français (Suisse)"
    },
    {
        key: "fr-FR",
        text: "프랑스어(프랑스) - Français (France)"
    },
    {
        key: "fy",
        text: "서부 프리지아어 - Frysk"
    },
    {
        key: "ga",
        text: "아일랜드어 - Gaeilge"
    },
    {
        key: "gd",
        text: "스코틀랜드 게일어 - Gàidhlig"
    },
    {
        key: "gl",
        text: "갈리시아어 - galego"
    },
    {
        key: "gn",
        text: "과라니어 - Guarani"
    },
    {
        key: "gu",
        text: "구자라트어 - ગુજરાતી"
    },
    {
        key: "ha",
        text: "하우사어 - Hausa"
    },
    {
        key: "haw",
        text: "하와이어 - ʻŌlelo Hawaiʻi"
    },
    {
        key: "hi",
        text: "힌디어 - हिन्दी"
    },
    {
        key: "hmn",
        text: "히몸어 - Hmong"
    },
    {
        key: "hr",
        text: "크로아티아어 - Hrvatski"
    },
    {
        key: "ht",
        text: "아이티어 - Créole haïtien"
    },
    {
        key: "hu",
        text: "헝가리어 - magyar"
    },
    {
        key: "hy",
        text: "아르메니아어 - հայերեն"
    },
    {
        key: "ia",
        text: "인터링구아 - interlingua"
    },
    {
        key: "id",
        text: "인도네시아어 - Indonesia"
    },
    {
        key: "ig",
        text: "이그보어 - Igbo"
    },
    {
        key: "is",
        text: "아이슬란드어 - íslenska"
    },
    {
        key: "it",
        text: "이탈리아어 - Italiano"
    },
    {
        key: "it-CH",
        text: "이탈리아어(스위스) - Italiano (Svizzera)"
    },
    {
        key: "it-IT",
        text: "이탈리아어(이탈리아) - Italiano (Italia)"
    },
    {
        key: "iw",
        text: "히브리어 - עברית"
    },
    {
        key: "ja",
        text: "일본어 - 日本語"
    },
    {
        key: "jv",
        text: "자바어 - Jawa"
    },
    {
        key: "ka",
        text: "조지아어 - ქართული"
    },
    {
        key: "kk",
        text: "카자흐어 - қазақ тілі"
    },
    {
        key: "km",
        text: "크메르어 - ខ្មែរ"
    },
    {
        key: "kn",
        text: "칸나다어 - ಕನ್ನಡ"
    },
    {
        key: "ko",
        text: "한국어"
    },
    {
        key: "kok",
        text: "코카니어 - कोंकणी"
    },
    {
        key: "ku",
        text: "쿠르드어 - kurdî"
    },
    {
        key: "ky",
        text: "키르기스어 - кыргызча"
    },
    {
        key: "la",
        text: "라틴어 - Latin"
    },
    {
        key: "lb",
        text: "룩셈부르크어 - Lëtzebuergesch"
    },
    {
        key: "ln",
        text: "링갈라어 - lingála"
    },
    {
        key: "lo",
        text: "라오어 - ລາວ"
    },
    {
        key: "lt",
        text: "리투아니아어 - lietuvių"
    },
    {
        key: "lv",
        text: "라트비아어 - latviešu"
    },
    {
        key: "mg",
        text: "말라가시어 - Malagasy"
    },
    {
        key: "mi",
        text: "마오리어 - Māori"
    },
    {
        key: "mk",
        text: "마케도니아어 - македонски"
    },
    {
        key: "ml",
        text: "말라얄람어 - മലയാളം"
    },
    {
        key: "mn",
        text: "몽골어 - монгол"
    },
    {
        key: "mr",
        text: "마라티어 - मराठी"
    },
    {
        key: "ms",
        text: "말레이어 - Melayu"
    },
    {
        key: "mt",
        text: "몰타어 - Malti"
    },
    {
        key: "my",
        text: "버마어 - မြန်မာ"
    },
    {
        key: "ne",
        text: "네팔어 - नेपाली"
    },
    {
        key: "nl",
        text: "네덜란드어 - Nederlands"
    },
    {
        key: "nn",
        text: "노르웨이어[니노르스크] - norsk nynorsk"
    },
    {
        key: "no",
        text: "노르웨이어 - norsk"
    },
    {
        key: "ny",
        text: "냔자어 - Nyanja"
    },
    {
        key: "oc",
        text: "오크어 - Occitan"
    },
    {
        key: "om",
        text: "오로모어 - Oromoo"
    },
    {
        key: "or",
        text: "오리야어 - ଓଡ଼ିଆ"
    },
    {
        key: "pa",
        text: "펀잡어 - ਪੰਜਾਬੀ"
    },
    {
        key: "pl",
        text: "폴란드어 - polski"
    },
    {
        key: "ps",
        text: "파슈토어 - پښتو"
    },
    {
        key: "pt",
        text: "포르투갈어 - Português"
    },
    {
        key: "pt-BR",
        text: "포르투갈어(브라질) - Português (Brasil)"
    },
    {
        key: "pt-PT",
        text: "포르투갈어(포르투갈) - Português (Portugal)"
    },
    {
        key: "qu",
        text: "케추아어 - Runasimi"
    },
    {
        key: "rm",
        text: "로만시어 - rumantsch"
    },
    {
        key: "ro",
        text: "루마니아어 - română"
    },
    {
        key: "ru",
        text: "러시아어 - Русский"
    },
    {
        key: "rw",
        text: "르완다어 - Kinyarwanda"
    },
    {
        key: "sd",
        text: "신디어 - سنڌي"
    },
    {
        key: "si",
        text: "싱할라어 - සිංහල"
    },
    {
        key: "sk",
        text: "슬로바키아어 - Slovenčina"
    },
    {
        key: "sl",
        text: "슬로베니아어 - slovenščina"
    },
    {
        key: "sm",
        text: "사모아어 - Samoan"
    },
    {
        key: "sn",
        text: "쇼나어 - chiShona"
    },
    {
        key: "so",
        text: "소말리아어 - Soomaali"
    },
    {
        key: "sq",
        text: "알바니아어 - shqip"
    },
    {
        key: "sr",
        text: "세르비아어 - српски"
    },
    {
        key: "st",
        text: "남부 소토어 - Southern Sotho"
    },
    {
        key: "su",
        text: "순다어 - Basa Sunda"
    },
    {
        key: "sv",
        text: "스웨덴어 - Svenska"
    },
    {
        key: "sw",
        text: "스와힐리어 - Kiswahili"
    },
    {
        key: "ta",
        text: "타밀어 - தமிழ்"
    },
    {
        key: "te",
        text: "텔루구어 - తెలుగు"
    },
    {
        key: "tg",
        text: "타지크어 - тоҷикӣ"
    },
    {
        key: "th",
        text: "태국어 - ไทย"
    },
    {
        key: "ti",
        text: "티그리냐어 - ትግርኛ"
    },
    {
        key: "tk",
        text: "투르크멘어 - türkmen dili"
    },
    {
        key: "tn",
        text: "츠와나어 - Tswana"
    },
    {
        key: "to",
        text: "통가어 - lea fakatonga"
    },
    {
        key: "tr",
        text: "터키어 - Türkçe"
    },
    {
        key: "tt",
        text: "타타르어 - татар"
    },
    {
        key: "ug",
        text: "위구르어 - ئۇيغۇرچە"
    },
    {
        key: "uk",
        text: "우크라이나어 - Українська"
    },
    {
        key: "ur",
        text: "우르두어 - اردو"
    },
    {
        key: "uz",
        text: "우즈베크어 - o‘zbek"
    },
    {
        key: "vi",
        text: "베트남어 - Tiếng Việt"
    },
    {
        key: "wa",
        text: "왈론어 - Walloon"
    },
    {
        key: "wo",
        text: "월로프어 - Wolof"
    },
    {
        key: "xh",
        text: "코사어 - IsiXhosa"
    },
    {
        key: "yi",
        text: "이디시어 - ייִדיש"
    },
    {
        key: "yo",
        text: "요루바어 - Èdè Yorùbá"
    },
    {
        key: "zh",
        text: "중국어 - 中文"
    },
    {
        key: "zh-CN",
        text: "중국어(간체) - 简体中文"
    },
    {
        key: "zh-HK",
        text: "중국어(홍콩) - 中文（香港）"
    },
    {
        key: "zh-TW",
        text: "중국어(번체) - 繁體中文"
    },
    {
        key: "zu",
        text: "줄루어 - isiZulu"
    }
];
